import { currentYear, getDaysInYear, getNumberOfWeeksInYear } from "./date";

const statusColors = {
  3: "bg-blue-500",
  0: "bg-green-500",
  1: "bg-orange-500",
  2: "bg-red-500",
};

export const getStatusColor = (status) => statusColors[status] ?? "bg-gray-500";

export const formatDate = (dateString) => {
  if (dateString === "") return null;
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "2-digit",
  }).format(new Date(dateString));
};

export const totalWidth = {
  monthly: 12 * 241,
  weekly: getNumberOfWeeksInYear(currentYear) * 241,
  daily: getDaysInYear(currentYear) * 241,
};

const timelineStatusColors = {
  3: "bg-blue-100 ring-1 ring-blue-500",
  0: "bg-green-100 ring-1 ring-green-500",
  1: "bg-orange-100 ring-1 ring-orange-500",
  2: "bg-red-100 ring-1 ring-red-500",
  default: "bg-gray-100 ring-1 ring-gray-500",
};

export const getTimelineStatusColor = (status, isCritical, critical) => {
  if (!critical)
    return timelineStatusColors[status] ?? timelineStatusColors.default;
  else if (isCritical && critical) return timelineStatusColors[2];
  else return timelineStatusColors.default;
};

const taskStatusMapper = {
  0: "Inprogress",
  1: "Monitoring",
  2: "Slipping",
  3: "Completed",
  4: "Onhold",
};

export const getTaskStatus = (status, isCritical, critical) => {
  return taskStatusMapper[status] ?? "-";
};

export const getWeeksInMonth = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const lastDay = new Date(year, month + 1, 0);

  const weeks = [];
  let currentWeek = [];

  for (let day = 1; day <= lastDay.getDate(); day++) {
    const currentDate = new Date(year, month, day);
    currentWeek.push(currentDate);

    if (currentDate.getDay() === 6 || day === lastDay.getDate()) {
      weeks.push(currentWeek);
      currentWeek = [];
    }
  }

  return weeks;
};

export function getCurrentWeek(date) {
  const currentDay = date.getDay();
  const diff = date.getDate() - currentDay + (currentDay === 0 ? -6 : 1);
  const monday = new Date(date.setDate(diff));

  const week = [];
  for (let i = 0; i < 7; i++) {
    const day = new Date(monday);
    day.setDate(monday.getDate() + i);
    week.push(day);
  }

  return week;
}


export function getNavigationFromEntityType(entityType) {
  let navigationType = null;
    switch (entityType) {
      case 'Project':
        navigationType = "Projects";
        break;
      case 'Program':
        navigationType = "Programs";
        break;
      case 'Portfolio':
        navigationType = "Portfolios";
        break;
    };

    return navigationType;
}